exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#uyh-app .mantra-format .mantras.image[data-v-7300a4b7],.responsivesite #wrapper #uyh-app .mantra-format .mantras.image[data-v-7300a4b7]{background-color:#fceff3}", ""]);

// exports
